export interface TenantConfig {
  slug: string;
  name: string;
  tagline: string;
  description?: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  logo: string;
  heroImage: string;
  currency: string;
  phone: string;
  address: string;
  city: string;
  postalCode?: string;
  hours: string;
  coordinates?: { lat: number; lng: number };
  website?: string;
  socialLinks: {
    instagram?: string;
    facebook?: string;
    whatsapp?: string;
  };
  externalLinks?: {
    tripadvisor?: string;
    uberEats?: string;
  };
}

export const TENANTS: Record<string, TenantConfig> = {
  'virabrasa': {
    slug: 'virabrasa',
    name: 'Virabrasa',
    tagline: 'Churrasqueira de Rodizio Premium',
    primaryColor: '#8B0000',
    secondaryColor: '#D4AF37',
    accentColor: '#FF6B35',
    logo: '/tenants/virabrasa/logo.svg',
    heroImage: '/tenants/virabrasa/hero.jpg',
    currency: 'EUR',
    phone: '+351 210 000 001',
    address: 'Rua das Brasas 100, Lisboa',
    city: 'Lisboa',
    hours: 'Ter-Dom: 12h00 - 23h30',
    socialLinks: {
      instagram: 'https://instagram.com/virabrasa',
      facebook: 'https://facebook.com/virabrasa',
      whatsapp: 'https://wa.me/351210000001',
    },
  },
  'frango-dourado': {
    slug: 'frango-dourado',
    name: 'Frango Dourado',
    tagline: 'Churrasqueira de Bairro em Atouguia da Baleia',
    description: 'Churrasqueira tradicional portuguesa especializada em frango assado na brasa, grelhados e peixe fresco. Comida caseira com sabor autêntico, para comer no local ou levar.',
    primaryColor: '#DAA520',
    secondaryColor: '#8B4513',
    accentColor: '#FF6B35',
    logo: '/tenants/frango-dourado/logo.svg',
    heroImage: '/tenants/frango-dourado/hero.jpg',
    currency: 'EUR',
    phone: '+351 917 101 106',
    address: 'Rua Dom Jerónimo de Ataíde 6/8, Atouguia da Baleia',
    city: 'Peniche, Leiria',
    postalCode: '2525-064',
    hours: 'Ter-Dom: 10h00 - 15h00',
    coordinates: { lat: 39.3367, lng: -9.3328 },
    socialLinks: {
      facebook: 'https://www.facebook.com/frangodouradoatouguia/',
      whatsapp: 'https://wa.me/351917101106',
    },
  },
  'brasa-quente': {
    slug: 'brasa-quente',
    name: 'Brasa Quente',
    tagline: 'Churrasco Artesanal com Cortes Selecionados',
    primaryColor: '#B22222',
    secondaryColor: '#2F4F4F',
    accentColor: '#FF4500',
    logo: '/tenants/brasa-quente/logo.svg',
    heroImage: '/tenants/brasa-quente/hero.jpg',
    currency: 'EUR',
    phone: '+351 230 000 003',
    address: 'Praca do Fogo 300, Coimbra',
    city: 'Coimbra',
    hours: 'Ter-Sab: 12h00 - 00h00 | Dom: 12h00 - 22h00',
    socialLinks: {
      instagram: 'https://instagram.com/brasaquente',
      facebook: 'https://facebook.com/brasaquente',
      whatsapp: 'https://wa.me/351230000003',
    },
  },
  'rei-dos-frangos': {
    slug: 'rei-dos-frangos',
    name: 'Rei dos Frangos',
    tagline: 'Frango assado, grelhados e take-away em várias lojas',
    description: 'Rede portuguesa de churrasqueiras Rei dos Frangos, com lojas de take-away e atendimento local em Coimbra, Leiria, Lisboa, Caldas da Rainha, Alcobaça, Fátima, Montijo, Entroncamento e Vieira de Leiria.',
    primaryColor: '#B71105',
    secondaryColor: '#221100',
    accentColor: '#F6A609',
    logo: '/tenants/rei-dos-frangos/logo.svg',
    heroImage: '/tenants/rei-dos-frangos/hero.jpg',
    currency: 'EUR',
    phone: '+351 239 702 240',
    address: 'Rua Dr Luís A. Duarte Santos, Nº 28, 3030-403 Coimbra',
    city: 'Coimbra',
    postalCode: '3030-403',
    hours: 'Todos os dias: 10h00 - 21h30',
    coordinates: { lat: 40.1955116, lng: -8.4040042 },
    website: 'https://reidosfrangos.pt/',
    socialLinks: {
      facebook: 'https://www.facebook.com/reidosfrangos/',
      whatsapp: 'https://wa.me/351239702240',
    },
    externalLinks: {
      tripadvisor: 'https://www.tripadvisor.pt/Restaurant_Review-g189143-d1065197-Reviews-Churrasqueira_Rei_dos_Frangos-Coimbra_Coimbra_District_Central_Portugal.html',
      uberEats: 'https://www.ubereats.com/pt/store/rei-dos-frangos-coimbra-vale-das-flores/2a2vuKIlVpik2nSdP4L9Mg',
    },
  },
  'joao-dos-leitoes': {
    slug: 'joao-dos-leitoes',
    name: 'Joao dos Leitoes',
    tagline: 'Especialista em Leitao Assado da Mealhada',
    primaryColor: '#800020',
    secondaryColor: '#4A2800',
    accentColor: '#C19A6B',
    logo: '/tenants/joao-dos-leitoes/logo.svg',
    heroImage: '/tenants/joao-dos-leitoes/hero.jpg',
    currency: 'EUR',
    phone: '+351 250 000 005',
    address: 'Rua do Leitao 500, Mealhada',
    city: 'Mealhada',
    hours: 'Qua-Dom: 11h00 - 22h00',
    socialLinks: {
      instagram: 'https://instagram.com/joaodossleitoes',
      facebook: 'https://facebook.com/joaodossleitoes',
      whatsapp: 'https://wa.me/351250000005',
    },
  },
  'taberna-da-fraga': {
    slug: 'taberna-da-fraga',
    name: 'Taberna da Fraga',
    tagline: 'Taberna Austríaca Portuguesa em Vila Nova de Poiares',
    description: 'Taberna austríaca portuguesa com cozinha tradicional portuguesa, vinhos requintados e ambiente acolhedor. Espaço exterior, estacionamento gratuito e Wi-Fi. Aberta de terça a domingo.',
    primaryColor: '#1B4332',
    secondaryColor: '#5C4033',
    accentColor: '#C9A227',
    logo: '/tenants/taberna-da-fraga/logo.svg',
    heroImage: '/tenants/taberna-da-fraga/hero.jpg',
    currency: 'EUR',
    phone: '+351 919 363 321',
    address: 'Estrada Nacional 17 N.396 A, 3350-211 Vila Nova de Poiares',
    city: 'Vila Nova de Poiares',
    postalCode: '3350-211',
    hours: 'Ter-Dom: 06h00 - 02h00 (Segunda encerrado)',
    coordinates: { lat: 40.2103, lng: -7.6905 },
    website: 'https://taberna-da-fraga.makro.bar/',
    socialLinks: {
      facebook: 'https://www.facebook.com/pages/Taberna-Da-Fraga/764098240456445',
      whatsapp: 'https://wa.me/351919363321',
    },
  },
  'etcetera': {
    slug: 'etcetera',
    name: 'Etcetera',
    tagline: 'Pizza artesanal, feita com tempo e ingredientes selecionados',
    description: 'Pizzaria artesanal em Oliveira do Hospital, com massa de longa fermenta\u00e7\u00e3o, tomate San Marzano e pizzas confecionadas no momento em forno napolitano.',
    primaryColor: '#7A1119',
    secondaryColor: '#1B1714',
    accentColor: '#E4A626',
    logo: '/tenants/etcetera/logo.svg',
    heroImage: '/tenants/etcetera/hero.jpg',
    currency: 'EUR',
    phone: '+351 913 850 423',
    address: 'Rua Dr. Ant\u00f3nio Ribeiro Garcia de Vasconcelos 1A',
    city: 'Oliveira do Hospital, Coimbra',
    postalCode: '3400-132',
    hours: 'Ter-S\u00e1b: 12h00-14h30 e 18h00-22h00 | Dom: 18h30-22h00 | Seg: encerrado',
    coordinates: { lat: 40.3608, lng: -7.8601 },
    socialLinks: {
      instagram: 'https://www.instagram.com/pizza_etcetera/',
      facebook: 'https://www.facebook.com/pizzaetcetera.pt/',
      whatsapp: 'https://wa.me/351913850423',
    },
    externalLinks: {
      tripadvisor: 'https://www.tripadvisor.pt/Restaurant_Review-g656855-d23761473-Reviews-Pizza_Etc-Oliveira_do_Hospital_Coimbra_District_Central_Portugal.html',
    },
  },
};

export function getTenant(slug: string): TenantConfig | null {
  return TENANTS[slug] ?? null;
}

export const TENANT_SLUGS = Object.keys(TENANTS);
